import React from "react";

import AddIcCallIcon from "@mui/icons-material/AddIcCall";
import IconBtnTemplate from "./IconBtnTemplate";

type IconSize = "small" | "inherit" | "medium" | "large";
type ButtonType = "success" | "danger" | "warning" | "info" | "generic";

interface AddPhoneIconBtnProps {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  size?: IconSize;
  tip?: string;
}

export default function AddPhoneIconBtn({
  action,
  type = "success",
  size = "small",
  tip = "Add Phone Number",
}: AddPhoneIconBtnProps) {
  return (
    <IconBtnTemplate
      type={type}
      action={action}
      icon={<AddIcCallIcon fontSize={size} />}
      tip={tip}
    />
  );
}
